export default [
    {
        path: '/documents',
        name: 'documents',
        component: () => import('@/views/Documents/Index.vue'),
        meta: {
            title: 'Zamawianie dokumentu',
            menuRendered: true,
            menuTitle: 'Zamawianie dokumentu',
            permission: ['docs_order'],
            icon: 'mdi-file-document',
        },
        redirect: { name: 'documentsDocuments' },
        children: [
            {
                path: '/documents/documents',
                name: 'documentsDocuments',
                component: () => import('@/views/Documents/Documents/Index.vue'),
                meta: {
                    title: 'Zamawianie dokumentu / Lista dokumentów',
                    menuTitle: 'Lista dokumentów',
                    requiresAuth: true,
                    permission: ['docs_order_read', 'docs_order_admin_read'],
                }
            },
            {
                path: '/documents/documents/create',
                name: 'documentsDocumentsCreate',
                component: () => import('@/views/Documents/Document/Index.vue'),
                meta: {
                    title: 'Zamawianie nowego dokumentu',
                    requiresAuth: true,
                    permission: ['docs_order_create', 'docs_order_admin_create'],
                },
            },
            {
                path: '/documents/documents/:id',
                name: 'documentsDocumentsEdit',
                component: () => import('@/views/Documents/Document/Index.vue'),
                meta: {
                    title: 'Zamawianie dokumentu / Edycja zamówienia',
                    requiresAuth: true,
                    permission: ['docs_order_update', 'docs_order_admin_update'],
                },
            },
        ]
    }
]
